import ceLogo from "./media/ce.png";
import backgroundImage from "./media/background.jpg";
import footerLogo from "./media/powered-by-healo.png";
import constants from "../../../../common/constants";
import SV_TRANSLATION from "./messages/sv";
import EN_TRANSLATION from "./messages/en";

const isProdEnv = process.env.REACT_APP_ENV === "production";

export default {
  name: "tennis",
  image: {
    text: "logo.text"
  },
  imagePost: {
    text: "logo.text"
  },
  imageQA: null,
  ceLogo: ceLogo,
  backGroundVideo: null,
  appBackground: {
    url: backgroundImage,
    overlayStyle: {
      opacity: 0.75,
      mixBlendMode: "multiply",
      backgroundImage: "linear-gradient(241deg, #d0e3e0, #a46450)"
    }
  },
  secondaryBackground: {
    backgroundColor: "rgb(208, 227, 224, 0.95)",
    gradientColors: ["rgb(208, 227, 224, 0.95)", "rgb(208, 227, 224, 0.85)"]
  },
  footerImage: footerLogo,
  baseClass: "brand-tennis",
  domains: [
    "http://localhost:4006",
    "https://dev-tennis.healo.app",
    "https://stg-tennis.healo.app",
    "https://tennis.healo.app"
  ],
  clinicCityEnabled: false,
  //set clinic id for PROD
  clinicId: isProdEnv ? 1114 : 1103,
  ssnEnabled: true,
  anonymousEnabled: true,
  registrationWithEmailEnabled: true,
  registrationWithPhoneEnabled: true,
  emailVerificationEnabled: false,
  additionalSpaceOnRegistrationForm: true,
  translation: {
    [constants.appLanguages.sv]: SV_TRANSLATION,
    [constants.appLanguages.en]: EN_TRANSLATION
  }
};



// WEBPACK FOOTER //
// ./src/modules/brand/brands/tennis/settings.js